import React from 'react';
import { Select } from 'syngenta-digital-cropwise-react-ui-kit';
import ChevronDown from 'assets/chevron_down.svg?react';
import ChevronUp from 'assets/chevron_up.svg?react';

export type SelectFieldOption = {
  label: string | React.ReactNode;
  value: string;
  disabled?: boolean;
};

export type SelectFieldProps = {
  id: string;
  label: string;
  options: SelectFieldOption[];
  required?: boolean;
  placeholder?: string;
  onChange?: (value: string) => void;
  onBlur?: (event: React.FocusEvent<HTMLSelectElement>) => void;
  defaultValue?: string;
  errorMessage?: string;
  value?: string;
  disabled?: boolean;
};

const SelectField = ({
  id,
  label,
  options,
  required,
  placeholder,
  defaultValue,
  onChange,
  onBlur,
  errorMessage,
  value,
  disabled = false
}: SelectFieldProps) => {
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

  const ChevronIcon = isDropdownOpen ? ChevronUp : ChevronDown;

  const hasError = Boolean(errorMessage);

  return (
    <div className="flex flex-col">
      <label htmlFor={id} className="text-neutral-60">
        {label}
        {required && <span className="text-red-60">*</span>}
      </label>
      <Select
        id={id}
        placeholder={placeholder}
        showSearch
        disabled={disabled}
        onDropdownVisibleChange={(open: boolean) => setIsDropdownOpen(open)}
        suffixIcon={<ChevronIcon width={18} height={18} />}
        defaultValue={defaultValue}
        onChange={onChange}
        onBlur={onBlur}
        status={hasError ? 'error' : undefined}
        value={value}
      >
        {options.map(option => (
          <Select.Option
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </Select.Option>
        ))}
      </Select>
      {hasError && <div className="text-red-60">{errorMessage}</div>}
    </div>
  );
};

export default SelectField;
